import { CUSTOM_LANDING_PAGE_OPTION_ID } from '@pages/IntroducingBroker/Dashboard/ReferralLink/ReferralLink'
import { TLinkStyles } from '@pages/IntroducingBroker/LinkHub/Links/types'

export const isCustomUrl = ({
  isCustomLpUrlSelected,
  isLinkShortened,
  isLinkExist,
  id,
}: {
  isCustomLpUrlSelected: boolean
  isLinkShortened: boolean
  isLinkExist: boolean
  id?: string
}) =>
  isCustomLpUrlSelected ||
  isLinkShortened ||
  (isLinkExist && !id) ||
  (isLinkExist && id === CUSTOM_LANDING_PAGE_OPTION_ID)

export const getLandingPageUrl = ({
  isCustomLpUrlSelected,
  customLandingPageUrl,
  id,
}: {
  isCustomLpUrlSelected: boolean
  customLandingPageUrl?: string | null
  id?: string
}) =>
  isCustomLpUrlSelected
    ? customLandingPageUrl
    : id !== CUSTOM_LANDING_PAGE_OPTION_ID
    ? id
    : undefined

export const getLinkStyles = (isMobile: boolean): TLinkStyles =>
  isMobile
    ? {
        mt: 'x16',
        direction: 'column',
        maxWidth: '100%',
      }
    : {
        mt: 'x20',
        align: 'center',
        maxWidth: '100%',
      }

// short redirect link served by the BE, alias resolver (302) example - https://my.tickmill.com/r/alias?ibCode=IB123&alias=my_alias
// the BE resolver validates against introducing_broker DB where codes are stored WITHOUT the
export const buildAliasShortUrl = (ibCode: string, alias: string): string => {
  const url = new URL('/r/alias', window.location.origin)
  url.searchParams.set('ibCode', ibCode.replace(/_?MT$/, ''))
  url.searchParams.set('alias', alias.trim().replace(/\s+/g, '_'))
  return url.toString()
}
